import '../global.js'
import select2 from "select2";
import 'select2/dist/css/select2.css';
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, Scrollbar, EffectFade } from "swiper/modules";
import { gsap, ScrollTrigger } from "gsap/all";
import { SplitText } from 'gsap/SplitText';
import { disableScroll, enableScroll } from './toggleScroll.js';

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, EffectFade]);
gsap.registerPlugin(SplitText, ScrollTrigger);
gsap.config({ nullTargetWarn: false });

import 'swiper/swiper-bundle.css';
import VideoModal from './VideoModal';
import 'jquery-validation';

export const MobileNav = () => {
    var navopener = $('.nav-opener'),
        navwrap = $('.nav-wrap'),
        links = navwrap.find('a'),
        navactive = 'nav-active';

    navwrap.on('click', '[data-modal]', function(e) {
        e.preventDefault();
        enableScroll();
    });

    navopener.click(function (e) {
        e.preventDefault();
        $('body').toggleClass(navactive);

        document.body.classList.contains(navactive) ? disableScroll() : enableScroll();
    });

    links.click(function () {
        $(this).hasClass('hasdrop-a') ? false : $('body').removeClass(navactive);
    });

    $('html').on('click', function (e) {
        var target = $(e.target);

        if (!(target.closest('[data-outside]').length) && !(target.closest('[data-outside] + [data-more-content]').length)) {
            $('[data-outside]').removeClass('active').next('[data-more-content]').slideUp(200);
        }
    });
}

export const Tabs = () => {
    $('ul.tabs li').click(function () {
        var tab_id = $(this).attr('data-tab');

        $(this).siblings().removeClass('current');
        $("#" + tab_id).siblings().removeClass('current');

        $(this).addClass('current');
        $("#" + tab_id).addClass('current');
    })
}

export const OpenClose = () => {
    $('[data-more]').next().hide();
    $('[data-more].active').next().show();

    $('[data-more]').click(function (e) {
        e.preventDefault();
        if ($(this).hasClass('active')) {
            $(this).removeClass('active').next().slideUp(200)
        } else if ($(this).hasClass('hasdrop-a')) {
            window.innerWidth <= 1024 ? $(this).addClass('active').next().slideToggle(200) : false;
        } else {
            $(this).addClass('active').next().slideToggle(200)
        }

        if ($(this).closest('[data-accordion]').length) {
            $(this).addClass('life');
            $(this).parent().siblings().find('[data-more]').removeClass('active');
            $(this).parent().siblings().find('[data-more]').next().slideUp(200);
        }
    })

    $('[data-outside]').next().find('a:not(.hasdrop-a):not([data-more])').click(function () {
        $('[data-outside]').removeClass('active').next('').slideUp(200);
    });
    $('[data-outside]').click(function (e) {
        $('[data-outside]').not(this).removeClass('active').next().slideUp(200);
    });

    $('html').on('click', function (e) {
        var target = $(e.target);

        if (!(target.closest('[data-outside]').length) && !(target.closest('[data-outside] + *').length)) {
            setTimeout(function () {
                $('[data-outside]').removeClass('active').next().slideUp(200);
            }, 200)
        }

        if (!(target.closest('[data-outside-1]').length) && !(target.closest('[data-outside-1] + *').length)) {
            setTimeout(function () {
                $('[data-outside-1]').removeClass('active').next().slideUp(200);
            }, 200)
        }
    });

    $(window).on("keyup", function () {
        if ($(".menu-item").is(':focus') && !$(document.activeElement).parent('.hasdrop').hasClass('focus')) {
            $(".hasdrop.focus").removeClass('focus');
            $(document.activeElement).parent('.hasdrop').addClass('focus');
            $('.hasdrop:not(.focus) .hasdrop-a').removeClass('active').next().removeClass('sm:opacity-100 sm:!visible');
        }
    });

    $(window).on("keydown", function (e) {
        if ($(".menu-item").is(':focus') && $(document.activeElement).parent('.hasdrop').hasClass('focus') && e.code === 'Space') {
            e.preventDefault();
            $(".focus .hasdrop-a").toggleClass('active').next().toggleClass('sm:!opacity-100 sm:!visible sm:!block');
        }
    });
}

export const toggleShowMore = (section) => {
    if (section.length <= 0) return
    const showMoreButton = document.querySelector('.show-more-button');
    if (!showMoreButton) return;

    document.addEventListener('click', (e) => {
        if (e.target.closest('.show-more-button')) {
            showMoreButton.querySelector('.closed-btn-text')?.classList.toggle('!hidden');
            showMoreButton.querySelector('.opened-btn-text')?.classList.toggle('!hidden');

            showMoreButton.querySelector('.arrow')?.classList.toggle('rotate-arrow-180');

            const showMoreContent = document.querySelector('.show-more-content');
            showMoreContent.classList.toggle('opened');
            const toggleAnimation = (showMoreContent) => {

                if (showMoreContent.classList.contains('opened')) {
                    gsap.to(showMoreContent, {
                        height: "auto",
                        duration: 0.5,
                        ease: "power1.inOut",
                    });
                } else {
                    gsap.to(showMoreContent, {
                        height: "0",
                        duration: 0.5,
                        ease: "power1.inOut",
                    });
                }
            };
            toggleAnimation(showMoreContent);
        }
    });
}




export const teamSectionAnimations = (sections) => {
    if (sections.length <= 0) return;
    sections.forEach((section) => {
        const filterButtons = section.querySelectorAll('.team-filter-categories');
        const filterPosts = section.querySelectorAll('.team-filter-content');
        const clearFiltersButton = section.querySelector('.team-filter-clear');
        const teamPopup = section.querySelector('.team-person-popup');
        const teamPopupContent = section.querySelector('.team-popup-content');
        const teamPopupGlass = section.querySelector('.team-person-popup-glass');
        const teamPopupWrapper = section.querySelector('.team-person-popup-wrapper');
        const teamSelect = section.querySelector('.section-team-gpx-select');
        let activeFilters = [];

        let scrollPosition = 0;
        let body = document.body;


        const togglePostsFilterAnimation = (filterPosts) => {
            filterPosts.forEach((post) => {
                if (post.classList.contains('gpx-posts-hidden')) {
                    gsap.to(post, {
                        height: 0,
                        opacity: 0,
                        duration: 0.2,
                        paddingBottom: 0,
                    });
                } else {
                    gsap.to(post, {
                        height: "auto",
                        opacity: 1,
                        duration: 0.2,
                        paddingBottom: 60,
                    });
                }
            });
        };
        const togglePopUpAnimation = (popUp, popupGlass, teamPopupWrapper) => {
            if (popUp.classList.contains('gpx-popup-hidden')) {
                gsap.to(teamPopupWrapper, {
                    opacity: 0,
                    zIndex: -99,
                    duration: 0.5,
                    ease: "linear",
                }).then(() =>
                    gsap.to(popupGlass, {
                        opacity: 0,
                        duration: 0.01,
                        ease: "linear",
                    }).then(() =>
                        gsap.to(popUp, {
                            delay: 0.06,
                            opacity: 0,
                            zIndex: -98,
                            duration: 0.05,
                            ease: "linear",
                        })
                    )
                )
                body.classList.toggle('n-gpx-body-not-scrollable');
                body.style.removeProperty('top');
                window.scrollTo(0, scrollPosition);
            } else {
                gsap.to(popUp, {
                    opacity: 1,
                    zIndex: 98,
                    duration: 0.05,
                    ease: "linear",
                }).then(() =>
                    gsap.to(popupGlass, {
                        opacity: 1,
                        duration: 0.05,
                        ease: "linear",
                    }).then(() =>
                        gsap.to(teamPopupWrapper, {
                            delay: 0.1,
                            opacity: 1,
                            zIndex: 99,
                            duration: 0.2,
                            ease: "linear",
                        })
                    )
                )
                scrollPosition = window.scrollY;
                body.classList.toggle('n-gpx-body-not-scrollable');
                body.style.top = `-${scrollPosition}px`;
            }
        };

        const filterPostsBySelectedCategory = (selectedCategory) => {
            if (!selectedCategory) {
                filterPosts.forEach(post => post.classList.remove('gpx-posts-hidden'));
                activeFilters.length = 0;
                togglePostsFilterAnimation(filterPosts);
            } else {
                filterPosts.forEach(post => post.classList.add('gpx-posts-hidden'));
                const index = activeFilters.indexOf(selectedCategory);
                index === -1 ? activeFilters.push(selectedCategory) : activeFilters.splice(index, 1);
                let postsToShow = [];
                filterPosts.forEach((item) => {
                    if (activeFilters.includes(item.id)) postsToShow.push(item)
                });
                postsToShow.forEach(post => post.classList.remove('gpx-posts-hidden'));

                if (postsToShow.length < 1) {
                    filterPosts.forEach(post => post.classList.remove('gpx-posts-hidden'));
                }
                activeFilters.length > 0 ? clearFiltersButton?.classList.add('gpx-show-button') : clearFiltersButton?.classList.remove('gpx-show-button');
                togglePostsFilterAnimation(filterPosts);
            }
        }


        if (teamSelect) {
            const customSelect = () => {
                $('.section-team-gpx-select').select2({
                    createTag: function (params) {
                        let term = $.trim(params.term);

                        if (term === '') {
                            return null;
                        }
                        return {
                            id: term,
                            width: 'resolve',
                            text: term,
                            newTag: true,
                        }
                    }
                });
                $('select.custom-select2').on('select2:select', function (e) {
                    const selectedFilter = e.params.data.element.dataset.categoryName;
                    filterPostsBySelectedCategory(selectedFilter);
                });
                $('select.custom-select2').on('select2:unselect', function (e) {
                    const unselectedFilter = e.params.data.element.dataset.categoryName;
                    filterPostsBySelectedCategory(unselectedFilter);
                });


                $('select.custom-select2').on('select2:opening select2:closing', function( event ) {
                    const $searchfield = $(this).parent().find('.select2-search__field');
                    $searchfield.prop('disabled', true);
                });

            }
            customSelect();
        }

        section.addEventListener('click', (e) => {
            const clickedFilterButton = e.target.closest('.team-filter-categories');
            if (clickedFilterButton) {
                clickedFilterButton.classList.toggle('gpx-filter-active');
                const filterName = clickedFilterButton.dataset.categoryName;
                filterPostsBySelectedCategory(filterName);

            } else if (e.target.closest('.team-filter-clear')) {
                filterButtons.forEach((btn) => {
                    btn.classList.remove('gpx-filter-active')
                });
                clearFiltersButton?.classList.remove('gpx-show-button');
                filterPostsBySelectedCategory();

            } else if (e.target.closest('.team-person-card')) {
                const currentEmployeeCard = e.target.closest('.team-person-card');
                if (currentEmployeeCard.classList.contains('team-no-popup')) {
                    return
                }
                ;
                const imageSource = currentEmployeeCard.querySelector('img').getAttribute('src');
                const employeeName = currentEmployeeCard.querySelector('h4').textContent;
                const employeePosition = currentEmployeeCard.querySelector('h4').textContent;
                const formattedEmployeeData = JSON.parse(currentEmployeeCard.getAttribute('data-employee-info'));

                teamPopupContent.innerHTML = `
            <div
            class="h-[310px] sm:h-[363px] max-w-[363px] w-[310px] sm:w-[363px] rounded-20 overflow-hidden basis-1/2">
                <img src="${imageSource}" class="object-cover w-full h-full">
            </div>
            <div class="text-white basis-1/2">
                <h4 class="pb-10 md:pb-12  text-xl md:text-28 leading-a30 md:leading-a11 text-white">
                ${employeeName}</h4>
                <p class="leading-a60 pb-15 md:pb-24 text-xs ">
                ${employeePosition}
                </p>
                <p class="leading-a30 text-base mt-0">${formattedEmployeeData.description}</p>
            </div>`;
                teamPopup.classList.remove('gpx-popup-hidden');
                togglePopUpAnimation(teamPopup, teamPopupGlass, teamPopupWrapper);
            } else if ((e.target.closest('.team-person-popup-close') || e.target.closest('.team-person-popup-glass')) && !e.target.closest('.team-popup-content')) {
                teamPopup.classList.add('gpx-popup-hidden');
                togglePopUpAnimation(teamPopup, teamPopupGlass, teamPopupWrapper);
            }
        });

        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' || e.key === 'Esc') {
                teamPopup.classList.add('gpx-popup-hidden');
                togglePopUpAnimation(teamPopup, teamPopupGlass, teamPopupWrapper);
            }
        });
    })
}

export const initSwiper = () => {
    const productHeroSlides = document.querySelectorAll('.product-hero-slider .swiper-slide');
    if (productHeroSlides.length > 1) {
        new Swiper(".product-hero-slider", {
            loop: true,
            autoHeight: true,
            slidesPerView: 1,
            navigation: {
                nextEl: '.product-hero-slider #productNextBtn',
                prevEl: '.product-hero-slider #productPrevBtn',
            },
        });
    }

    const blockquoteSlides = document.querySelectorAll('.blockquote-slider .swiper-slide');
    if (blockquoteSlides.length > 1) {
        new Swiper(".blockquote-slider", {
            loop: true,
            autoplay: {
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
                delay: 8000
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }

    const blockquoteTypeCSlides = document.querySelectorAll('.blockquote-type-c-slides .swiper-slide');
    if (blockquoteTypeCSlides.length > 1) {
        const blockquoteSlide = new Swiper(".blockquote-type-c-slides", {
            loop: true,
            effect: "fade",
            autoHeight: true,
            autoplay: {
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
                delay: 8000
            },
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
                clickable: true,
                formatFractionCurrent: function (number) {
                    return ('0' + number).slice(-2);
                },
                formatFractionTotal: function (number) {
                    return ('0' + number).slice(-2);
                }
            },
            navigation: {
                nextEl: '#nextBtn',
                prevEl: '#prevBtn',
            },
        });

        blockquoteSlide.on('slideChangeTransitionStart', (swiper) => {
            const split = new SplitText(swiper.slides[swiper.activeIndex].querySelector('blockquote p'), { type: "lines" });
            const revertSplitText = () => split.revert();

            gsap.from(split.lines, {
                ease: "sine.out",
                duration: 0.7,
                y: "110%",
                autoAlpha: 0,
                stagger: 0.1,
                onComplete: revertSplitText
            });
        });

        blockquoteSlide.init();
    }

    const tabsSliderSlides = document.querySelectorAll('.tabs-slider .swiper-slide');
    if (tabsSliderSlides.length > 1) {
        const sliderPauseBtn = document.querySelector('.button-swiper-pause');
        const sliderNextBtn = document.querySelector('#tabNextBtn');
        const sliderPrevBtn = document.querySelector('#tabPrevBtn');
        const btnIcons = sliderPauseBtn.querySelectorAll('.button-icon');
        const tabsProgress = document.querySelectorAll(".tabs-progress");

        const tabsSlider = new Swiper(".tabs-slider", {
            loop: false,
            effect: "fade",
            speed: 300,
            autoplay: {
                delay: 8000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<button class="' + className + ' tab-bullet relative text-center md:min-w-[230px] sm:!left-auto opacity-50 hover:opacity-70 !rounded-none text-[20px] lg:text-[24px] leading-none font-normal p-15 md:p-25 transition-all whitespace-nowrap cursor-pointer">' + tabsSliderSlides[index].dataset.title + '</button>';
                },
            },

            breakpoints: {
                320: {
                    pagination: {
                        dynamicBullets: true,
                    }
                },
                768: {
                    pagination: {
                        dynamicBullets: false,
                    }
                }
            },

            on: {
                autoplayTimeLeft(s, time, progress) {
                    tabsProgress.forEach(item => item.style.width = `${106.6 * (1 - progress)}%`);
                },

                slideChange: (swiper) => {
                    const prevActiveSlide = swiper.slides[swiper.previousIndex];
                    const activeSlide = swiper.slides[swiper.activeIndex];

                    gsap.timeline().fromTo(prevActiveSlide.querySelector('.tab-content'), {
                        duration: 0.3,
                        y: 0,
                        opacity: 1
                    }, { y: 50, opacity: 0 })
                        .fromTo(activeSlide.querySelector('.tab-content'), { duration: 0.3, y: 50, opacity: 0 }, {
                            y: 0,
                            opacity: 1,
                            delay: 0.1
                        });

                    gsap.timeline().fromTo(prevActiveSlide.querySelector('img'), {
                        duration: 0.3,
                        opacity: 1
                    }, { opacity: 0 })
                        .fromTo(activeSlide.querySelector('img'), { duration: 0.3, opacity: 0 }, {
                            opacity: 1,
                            delay: 0.1
                        });

                    btnIcons.forEach(icon => icon.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M16 4L16 20" stroke="white" stroke-width="1.5" stroke-linecap="round"/><path d="M8 4L8 20" stroke="white" stroke-width="1.5" stroke-linecap="round"/></svg>');
                },
            }
        });

        if (sliderPauseBtn) {
            sliderPauseBtn.addEventListener('click', () => {
                if (tabsSlider.autoplay.paused) {
                    tabsSlider.autoplay.resume();
                    btnIcons.forEach(icon => icon.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M16 4L16 20" stroke="white" stroke-width="1.5" stroke-linecap="round"/><path d="M8 4L8 20" stroke="white" stroke-width="1.5" stroke-linecap="round"/></svg>');
                } else {
                    tabsSlider.autoplay.pause();
                    btnIcons.forEach(icon => icon.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8 20L8 4L20 12L8 20Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
                }
            });
        }

        if(sliderNextBtn) sliderNextBtn.addEventListener('click', () => (tabsSlider.activeIndex == tabsSlider.slides.length - 1) ? tabsSlider.slideTo(0) : tabsSlider.slideNext());
        if(sliderPrevBtn) sliderPrevBtn.addEventListener('click', () => (tabsSlider.activeIndex == 0) ? tabsSlider.slideTo(tabsSlider.slides.length - 1) : tabsSlider.slidePrev());
    }

    new Swiper(".mySwiper", {
        slidesPerView: "auto",
        spaceBetween: 48,
        slidesPerView: 1,

        scrollbar: {
            el: ".swiper-scrollbar",
        },

        breakpoints: {
            640: {
                slidesPerView: 2,
            }
        },
    });

    new Swiper(".hero-slider", {
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: true,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 48,
                allowTouchMove: false
            },
        },
    });

    new Swiper(".mobile-swiper", {
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
}

export const MobileSwiper = () => {
    const breakpoint = window.matchMedia('(min-width:768px)');

    if (document.querySelectorAll('[data-mobile-swiper]').length === 0) return;

    let mySwiper;

    const breakpointChecker = function () {
        if (breakpoint.matches === true) {
            if (mySwiper !== undefined) [...mySwiper].forEach(element => element.destroy(true, true));
            return;
        } else if (breakpoint.matches === false) {
            return enableSwiper();
        }
    }

    const enableSwiper = function () {
        mySwiper = new Swiper('[data-mobile-swiper]', {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 24,
            centeredSlides: true,
            // autoplay: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
}

export const FixedHeader = () => {
    var header = $("#header");

    classToggle()

    $(window).scroll(function () {
        classToggle()
    });

    function classToggle() {
        var scroll = $(window).scrollTop();
        if (scroll >= 18) {
            header.addClass("sticky");
        } else {
            header.removeClass("sticky");
        }
    }
};

export const openModal = (modal) => {
    $('body').addClass('modal-active');
    $('.modal').removeClass('show');
    $(modal).addClass('show');
    $(document).trigger("modal:open", { modal })
}

export const Modal = () => {
    $('[data-modal]').on('click', function (e) {
        e.preventDefault();
    });


    jQuery('html').on('click touchstart pointerdown MSPointerDown', function (e) {
        var target = jQuery(e.target);
        if (!target.closest('[data-modal-box]').length) {
            $('[data-modal-box]').parents('.show').removeClass('show');
            $('[data-modal-box].show').removeClass('show');
            $(target).parents('.modal-active').removeClass('modal-active');
        }
    });
}

export const InputFocus = () => {
    var input = $('.input');
    input.each(function () {
        var placeholder = $(this).attr('placeholder');
        if (placeholder != undefined) {
            $(this).attr('placeholder', '');
            $(this).parent().append('<span class="input-placeholder">' + placeholder + '</span>');
        }
    });
    input.focus(function () {
        $(this).parent().addClass('typing');
    });
    input.blur(function () {
        if ($(this).val() == 0) {
            $(this).parent().removeClass('typing');
        } else {
            $(this).parent().addClass('typing');
        }
    });
}

export const ModalVideo = () => {
    VideoModal.init();
}

export const ProgressBar = () => {
    let progressBars = document.getElementsByClassName('progressbar');

    $(window).scroll(function () {
        if (progressBars.length > 0) {
            for (let i = 0; i < progressBars.length; i++) {
                let progressBar = progressBars[i];
                let boundingClientRect = progressBar.getBoundingClientRect();
                let top = boundingClientRect.top;
                let windowHeight = window.innerHeight;

                if (top >= 0 && top <= windowHeight) {
                    let percentage = (top - windowHeight) / -windowHeight * 100;

                    if (percentage > 98) {
                        percentage = 98;
                    }

                    let bar = progressBar.querySelector('.bar');
                    bar.style.width = percentage + '%';
                }
            }
        }
    });
}

export const CountDown = () => {
    let hasCounterStarted = false;
    const items = $('[data-counter]');

    if (!items.length) return;

    startCounter();
    document.addEventListener('scroll', () => {
        startCounter();
    });

    function startCounter() {
        if (!hasCounterStarted && isInViewport(items[0])) {
            items.each(function () {
                $(this).prop('Counter', 0).animate({
                    Counter: $(this).data('counter')
                }, {
                    duration: 3000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))
                    }
                });
            });
            hasCounterStarted = true;
        }
    }

    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
}

export const LeadFormValidator = () => {
    jQuery('.lead-form').each((index, element) => {
        jQuery(element).validate({
            submitHandler: function (form) {
                if (!hcaptcha.getResponse()) {
                    return;
                }

                var form = jQuery(form);
                var button = form.find('button');
                var thanks = form.next('.thanks-message');
                button.addClass('loading').attr('disabled', true);
                jQuery.post(form.attr('action'), form.serialize(), data => {
                    var firstName = form.find('input[name="first_name"]').val();
                    thanks.find('.first-name').text(firstName);
                    thanks.removeClass('hidden');
                    form.addClass('hidden');
                });
                return;
            },
            errorPlacement: function () {
                return;
            }
        });
    });
}

export const TOC = () => {
    const tocDesktop = $('.toc-list');
    if (tocDesktop.length) {
        let activeNavItem = -1;
        const tocAnchors = $('[data-toc-header]');
        if (tocAnchors.length) {
            tocDesktop.parent().removeClass('hidden')
            tocDesktop.empty();
            tocAnchors.each((i, elem) => {
                const $elem = $(elem);
                const $id = `section-${i}`;
                const $li = $('<li/>');
                $elem.attr('id', $id);
                const $anchor = $('<a/>')
                    .attr('href', `#${$id}`)
                    .text($elem.attr('data-toc-header'));
                if (0 === i) {
                    $anchor.addClass('active');
                }
                $li.append($anchor).appendTo(tocDesktop);
            });
            $('.toc-list a').click(function () {
                $(this).parents('.toc-list').find('li').removeClass('active');
                $(this).parent().addClass('active');
                $('html, body').stop().animate({
                    scrollTop: $($(this).attr('href')).offset().top - 120
                }, 300);
                return false;
            });

            $(window).scroll(() => {
                const scrollDistance = $(window).scrollTop();
                let activeItem = 0;
                tocAnchors.each(function (i) {
                    if ($(this).position().top - 200 <= scrollDistance) {
                        activeItem = i;
                    }
                });
                if (activeItem !== activeNavItem) {
                    $('.toc-list li.active').removeClass('active');
                    $('.toc-list li').eq(activeItem).addClass('active');
                    activeNavItem = activeItem;
                }
            }).scroll();

        } else {
            tocDesktop.parent().addClass('hidden')
        }
    }
}

export const WpImageWidth = () => {
    const img = document.querySelectorAll('.article-wp .wp-caption');
    img.forEach(item => {
        const width = item.style.width;
        item.style.width = null;
        item.style.maxWidth = width
    })
}

// export const CategoryFilter = () => {
//     const debounce = (func, wait) => {
//         let timeout;

//         return function executedFunction(...args) {
//             const later = () => {
//                 clearTimeout(timeout);
//                 func(...args);
//             };

//             clearTimeout(timeout);
//             timeout = setTimeout(later, wait);
//         };
//     };

//     // var form = $('#cat-filter');
//     // if (form.length) {

//     //     form.change(function () {
//     //         filter()
//     //         return false;
//     //     });

//     //     document.querySelector('.form-submit').addEventListener('click', () => {
//     //         console.log('click')
//     //     })

//     //     // $('.form-submit').on('click', function () {
//     //     //     console.log('click')
//     //     // });

//     //     console.log($('.form-submit'))

//     //     $('#cat-filter input[name="query"]').on('input', debounce(filter(), 300));

//     //     function filter() {
//     //         var base = location.protocol + '//' + location.host + location.pathname;
//     //         var url = base + '?' + form.serialize();
//     //         window.history.pushState('', document.title, url);

//     //         console.log(form.serialize());

//     //         $.get(url, (data) => {
//     //             $('.blog-post-list').parent().html(jQuery(data).find('.blog-post-list').parent().children()).addClass('active');
//     //         });

//     //         setTimeout(() => {
//     //             (new AjaxLoadMore());
//     //         }, 200);
//     //     }
//     // }

//     const blogTemplate = document.querySelector('.blog-template');

//     if(!blogTemplate) return;

//     console.log(blogTemplate);

//     const filterForm = blogTemplate.querySelector('[data-filter-form]');
//     if (!filterForm) return;
//     console.log(filterForm);
//     const filterFormItemsContainer = blogTemplate.querySelector('.blog-post-list'),
//     filterFormButton = blogTemplate.querySelector('.btn-load-more'),
//     filterFormButtonText = filterFormButton.querySelector('.text span'),
//     searchField = blogTemplate.querySelector('.filter__search input'),
//     buttonTopic = blogTemplate.querySelector('.filter__topics'),
//     buttonAssetType = blogTemplate.querySelector('.filter__asset-type'),
//     nonce = themeVars.nonce;
//     let isLoadingFlag = false;

//     console.log(themeVars);

//     function updateRadio (list) {
//         // let radio_button;

//         list.addEventListener('click', function(e) {
//             // if(e.target.classList.contains('filter__input')) {
//             //     if (radio_button === e.target) {
//             //         e.target.checked = false;
//             //         radio_button = null;
//             //         yourFrontEndAjaxCall('change');
//             //     } else {
//             //         radio_button = e.target;
//             //     }
//             // }
//             console.log(e.target);
//         });
//     }

//     function yourFrontEndAjaxCall (type, loadMorePage) {
//         const filterFormButtonInitialText = filterFormButtonText.textContent;
//         console.log('init')

//         if (isLoadingFlag) return;

//         isLoadingFlag = true;
//         const activeTopic = blogTemplate.querySelector('input[name="topic"]:checked')?.value;
//         const activeAssetType = blogTemplate.querySelector('input[name="asset_type"]:checked')?.value;
//         filterForm.classList.add('loading');
//         filterFormButtonText.textContent = 'Loading...';

//         fetch(themeVars.ajaxUrl, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//             body: `action=ajax_filter_fn&nonce=${nonce}&page=${loadMorePage ? loadMorePage : 1}${activeTopic ? `&topic=${activeTopic}` : ''}${activeAssetType ? `&asset_type=${activeAssetType}` : ''}
//             &s=${searchField ? searchField.value : ''}`,
//         })
//             .then(async response => {
//                 if (!response.ok) {
//                     if (response.status === 503) {
//                         return new Promise((resolve) => setTimeout(resolve, 3000)).then(yourFrontEndAjaxCall);
//                     } else {
//                         throw new Error('Network response was not ok');
//                     }
//                 }

//                 return response.json();
//             })
//             .then(data => {
//                 if(type === 'change' || data.total_pages === 0) {
//                     filterFormItemsContainer.innerHTML = data.response_compile;
//                     console.log(data);
//                 } else {
//                     filterFormItemsContainer.insertAdjacentHTML( 'beforeEnd', data.response_compile );
//                     console.log(data);
//                 }

//                 if(filterFormButton) {
//                     filterFormButton.dataset.page = data.total_pages <= data.page ? 1 : Number(data.page) + 1;
//                     filterFormButton.style.display = data.total_pages <= data.page ? 'none' : 'inline-block';
//                 }
//             })
//             .catch((error) => console.log(error))
//             .finally(() => {
//                 isLoadingFlag = false;
//                 filterForm.classList.remove('loading');
//                 if(filterFormButton) filterFormButtonText.textContent = filterFormButtonInitialText;
//             });
//     }

//     filterFormButton && filterFormButton.addEventListener('click', (e) => {
//         e.preventDefault();
//         yourFrontEndAjaxCall('update', filterFormButton.dataset.page);
//     });

//     yourFrontEndAjaxCall('change');

//     searchField && searchField.addEventListener('keyup', () => debounce((searchField.value.length >= 3 || searchField.value.length === 0) && yourFrontEndAjaxCall('change'), 100));
//     filterForm && filterForm.addEventListener('change', () => yourFrontEndAjaxCall('change'));
    
//     buttonTopic && updateRadio(buttonTopic);
//     buttonAssetType && updateRadio(buttonAssetType);
// }

export const updatePartnersSliderWidth = () => {
    const animationSlider = document.querySelectorAll('.partners__wrap');
    if (!animationSlider) return;

    animationSlider.forEach(slider => slider.style.width = `${slider.scrollWidth + 20}px`);
}


export const tooltipAnimation = () => {
    const tooltipLinks = document.querySelectorAll('.tooltip-link');
    let currentLink = null;

    const hideAllModels = () => {
        document.querySelectorAll('.tooltip-modal').forEach(modal => {
            modal.classList.remove('show');
        });
    }


    const currentOffset = (currentLink, tooltipModal) => {
        let linkRect = currentLink.getBoundingClientRect();
        let offsetX = event.clientX - linkRect.left;

        if (tooltipModal && tooltipModal.offsetWidth) {
            offsetX = Math.max(0, Math.min(offsetX, linkRect.width));
            tooltipModal.style.left = `${offsetX}px`;
        }
    };


    document.addEventListener('mousemove', (event) => {
        if (currentLink) {
            let tooltipModal = currentLink.querySelector('.tooltip-modal');
            let linkRect = currentLink.getBoundingClientRect();

            let offsetX = event.clientX - linkRect.left;

            if (tooltipModal && tooltipModal.offsetWidth) {
                offsetX = Math.max(0, Math.min(offsetX, linkRect.width));

                tooltipModal.style.left = `${offsetX}px`;
            }
        }
    });


    tooltipLinks.forEach((link) => {
        link.addEventListener('mouseenter', (e) => {
            if (window.innerWidth >= 1280) {
                currentLink = e.currentTarget;
                hideAllModels();

                const tooltipModal = currentLink.querySelector('.tooltip-modal');
                tooltipModal.classList.add('show');
                currentOffset(currentLink, tooltipModal);
            }
        });

        link.addEventListener('mouseleave', () => {
            currentLink = null;

            hideAllModels();
        });

        link.addEventListener('focus', (e) => {
            hideAllModels();

            currentLink = e.currentTarget;
            let tooltipModal = currentLink.querySelector('.tooltip-modal');

            currentOffset(currentLink, tooltipModal);
        });

        link.addEventListener('blur', () => {
            hideAllModels();
        });
    });
}

export const fadeUpAnimation = (
    target,
    trigger,
    startTl = "top center",
    opacityParam = 1,
    durationAnim = 0.7,
    yParam = '110%',
    position = ""
) => {
    const split = new SplitText(target, { type: "lines" });
    gsap.set(split.lines, { y: yParam, opacity: 0 });
    const revertSplitText = () => split.revert();
    const animation = gsap.timeline({ defaults: { stagger: 0.1, duration: durationAnim } })
        .to(split.lines, { y: 0, opacity: opacityParam, onComplete: revertSplitText }, position);

    ScrollTrigger.create({
        trigger: trigger,
        start: startTl,
        animation: animation,
        toggleActions: "play none none none",
    });
};

export const fadeAnimation = (
    target,
    trigger,
    startTl = "top center",
    opacityParam = 1,
    durationAnim = 0.7,
    delay = 0.3
) => {
    gsap.set(target, { opacity: 0 });
    const animation = gsap.timeline({ defaults: { duration: durationAnim } })
        .fromTo(target, { opacity: 0 }, { opacity: opacityParam, delay: delay });

    ScrollTrigger.create({
        trigger: trigger,
        start: startTl,
        animation: animation,
        toggleActions: "play none none none",
    });
};

export const industriesCardsContentHeight = () => {
    const cards = document.querySelectorAll('.industries-card');
    if (!cards.length) return;

    cards.forEach(card => {
        const content = card.querySelector('.industries-card .content');
        const title = content.querySelector('.title');
        const titleHeight = title.offsetHeight;
        const contentHeight = content.offsetHeight;
        content.style.top = `${contentHeight - (titleHeight + 80)}px`;

        card.addEventListener('mouseover', () => {
            content.style.top = '20px';
            content.style.overflowY = 'scroll';
        });

        card.addEventListener('mouseout', () => {
            content.style.top = `${contentHeight - (titleHeight + 80)}px`;
            content.style.overflowY = 'hidden';
            content.scrollTop = 0;
        });
    });
}

export const parallaxOverlapAnimation = () => {
    const parallaxSections = [...document.querySelectorAll('.parallax-section')];

    if (parallaxSections.length === 0) return;

    let mm = gsap.matchMedia();

    ScrollTrigger.getAll().forEach(ST => {
        if(ST.trigger?.classList.contains('parallax-section')) ST.kill();
    });


    mm.add("(min-width: 1025px)", () => {

        parallaxSections.forEach((section) => {
            const animTm = gsap.timeline();
            animTm.to(section.querySelector('.parallax-section-child'), { y: 250, duration: 9 });

            ScrollTrigger.create({
                trigger: section,
                start: "bottom bottom",
                end: "bottom center",
                scrub: true,
                animation: animTm,
                refreshPriority: -1,
            })
        })

    });

    mm.add("(max-width: 1024px)", () => {
        // Mobile Animations
    });
}

export const showMoreWithGrid = (btn) => {
    const content = btn.closest('.wrapp-show-more');
    const btnText = btn.querySelector('span');
    content.classList.toggle('opened');
    content.classList.contains('opened') ? btnText.innerHTML = btn.dataset.closeText : btnText.innerHTML = btn.dataset.openText;
}


export const focusLabelAnimation = ()=>{
    document.querySelector('.gfield--type-email input[type="email"]').addEventListener("focus", (event) => {
        if(event.target.closest('.gfield--type-email')) event.target.closest('.gfield--type-email').classList.add('focus');
    });

    document.querySelector('.gfield--type-email input[type="email"]').addEventListener("blur", (event) => {
        document.querySelector('.gfield--type-email').classList.remove('focus');
    });
}

export const showCTABottomButton = ()=>{
    if(!document.querySelector('.cta-bottom')) return;
    setTimeout(()=>{
        document.querySelector('.cta-bottom').classList.add('show');
    }, 2000)
}

